var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Divider, Grid2 as Grid, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import MaskedTextFieldControl from '../../../components/Form/MaskedTextFieldControl';
import TextFieldControl from '../../../components/Form/TextFieldControl';
import EstadoSelect from '../../../components/Form/EstadoSelect';
import MunicipioSelect from '../../../components/Form/MunicipioSelect';
import { useWizard } from '../../../components/Wizard/useWizard';
import { useProcessContext } from '../context/ProcessContext';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { getDisabledFlags } from '../../../util/analise.utils';
import { EntidadeAnalise } from '../../../enums/analise.enum';
import { AnaliseGrupoStatusComponent } from '../../../components/Analise/AnaliseGrupoStatusComponent';
import { isValidCnpj } from '../../../util/is-valid-cnpj.util';
import { formatPhone, PHONE_MASK } from '../../../util/masks';
var createEmpresaSchema = function (disabledDadosGerais, disabledEndereco, disabledContato) {
    return z.object({
        cnpj: disabledDadosGerais
            ? z.string().optional()
            : z
                .string()
                .min(14, 'CNPJ inválido')
                .regex(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/)
                .refine(function (cnpj) { return isValidCnpj(cnpj); }, {
                message: 'CNPJ informado é inválido',
            }),
        nomeFantasia: disabledDadosGerais
            ? z.string().optional()
            : z
                .string()
                .min(1, 'Nome Fantasia é obrigatório')
                .max(100, 'Tamanho máximo excedido.'),
        razaoSocial: disabledDadosGerais
            ? z.string().optional()
            : z
                .string()
                .min(1, 'Razão Social é obrigatória')
                .max(100, 'Tamanho máximo excedido.'),
        cep: disabledEndereco
            ? z.string().optional()
            : z
                .string()
                .min(9, 'CEP inválido')
                .regex(/^\d{5}-\d{3}$/),
        logradouro: disabledEndereco
            ? z.string().optional()
            : z
                .string()
                .min(1, 'Logradouro é obrigatório')
                .max(100, 'Tamanho máximo excedido.'),
        numero: disabledEndereco
            ? z.string().optional()
            : z
                .string()
                .min(1, 'Número é obrigatório')
                .max(10, 'Tamanho máximo excedido.'),
        complemento: disabledEndereco
            ? z.string().optional()
            : z.string().max(100, 'Tamanho máximo excedido.').optional(),
        bairro: disabledEndereco
            ? z.string().optional()
            : z
                .string()
                .min(1, 'Bairro é obrigatório')
                .max(100, 'Tamanho máximo excedido.'),
        cidade: disabledEndereco
            ? z.number().optional()
            : z
                .number({ message: 'Selecione o município' })
                .min(1, 'Cidade é obrigatória'),
        uf: disabledEndereco
            ? z.string().optional()
            : z.string().min(1, 'UF é obrigatória'),
        email: disabledContato
            ? z.string().optional()
            : z
                .string()
                .email('E-mail inválido')
                .max(100, 'Tamanho máximo excedido.'),
        telefone: disabledContato
            ? z.string().optional()
            : z
                .string()
                .min(14, 'Telefone inválido')
                .regex(/^\(\d{2}\) \d{4,5}-\d{4}$/),
    });
};
var DEFAULT_VALUES = {
    cnpj: '',
    nomeFantasia: '',
    razaoSocial: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    email: '',
    telefone: '',
};
export var DadosEmpresaForm = function (_a) {
    var _b, _c;
    var _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var navigate = useNavigate();
    var _e = useWizard(), nextStep = _e.nextStep, isFirstStep = _e.isFirstStep, prevStep = _e.prevStep;
    var _f = useProcessContext(), updateEmpresa = _f.updateEmpresa, processo = _f.processo, analise = _f.analise;
    var empresa = processo === null || processo === void 0 ? void 0 : processo.empresa;
    var _g = getDisabledFlags(EntidadeAnalise.EMPRESA, (_b = processo === null || processo === void 0 ? void 0 : processo.empresa) === null || _b === void 0 ? void 0 : _b.id, analise === null || analise === void 0 ? void 0 : analise.gruposCampos, disabled), disabledDadosGerais = _g.disabledDadosGerais, disabledEndereco = _g.disabledEndereco, disabledContato = _g.disabledContato;
    var _h = useForm({
        resolver: zodResolver(createEmpresaSchema(disabledDadosGerais, disabledEndereco, disabledContato)),
        defaultValues: empresa
            ? __assign(__assign({}, empresa), { complemento: (_c = empresa.complemento) !== null && _c !== void 0 ? _c : '', telefone: formatPhone(empresa.telefone) }) : DEFAULT_VALUES,
    }), control = _h.control, handleSubmit = _h.handleSubmit, watch = _h.watch, isSubmitting = _h.formState.isSubmitting;
    var handleClickBack = function () {
        if (!isFirstStep) {
            prevStep();
        }
        else {
            navigate('/processo');
        }
    };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (disabled) {
                        nextStep();
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateEmpresa(data)];
                case 2:
                    _a.sent();
                    enqueueSnackbar('Dados da empresa atualizados com sucesso!', {
                        variant: 'success',
                    });
                    nextStep();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Erro ao atualizar dados da empresa:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, children: [_jsx(Typography, { variant: "h6", children: "Informa\u00E7\u00F5es B\u00E1sicas" }), _jsxs(AnaliseGrupoStatusComponent, { analise: analise, entidade: 'EMPRESA', grupo: 'DADOS_GERAIS', entidadeAssociadaId: empresa === null || empresa === void 0 ? void 0 : empresa.id, children: [_jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MaskedTextFieldControl, { name: "cnpj", label: "CNPJ", control: control, mask: "00.000.000/0000-00", required: true, disabled: disabledDadosGerais }) }) }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "nomeFantasia", label: "Nome Fantasia", control: control, required: true, disabled: disabledDadosGerais }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "razaoSocial", label: "Raz\u00E3o Social", control: control, required: true, disabled: disabledDadosGerais }) })] })] }), _jsx(Divider, { sx: { mt: 3 } }), _jsx(Typography, { variant: "h6", children: "Dados de Endere\u00E7o" }), _jsx(AnaliseGrupoStatusComponent, { analise: analise, entidade: "EMPRESA", grupo: "ENDERECO", entidadeAssociadaId: empresa === null || empresa === void 0 ? void 0 : empresa.id, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MaskedTextFieldControl, { name: "cep", label: "CEP", control: control, mask: "00000-000", required: true, disabled: disabledEndereco }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx("br", {}) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "logradouro", label: "Logradouro", control: control, required: true, disabled: disabledEndereco }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "numero", label: "N\u00FAmero", control: control, required: true, disabled: disabledEndereco }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "complemento", label: "Complemento", control: control, disabled: disabledEndereco, maxLength: 100 }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "bairro", label: "Bairro", control: control, required: true, disabled: disabledEndereco }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(EstadoSelect, { name: "uf", control: control, required: true, disabled: disabledEndereco }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MunicipioSelect, { name: "cidade", control: control, estadoSigla: watch('uf'), required: true, disabled: disabledEndereco }) })] }) }), _jsx(Divider, { sx: { mt: 3 } }), _jsx(Typography, { variant: "h6", children: "Dados de Contato" }), _jsx(AnaliseGrupoStatusComponent, { analise: analise, entidade: "EMPRESA", grupo: "CONTATO", entidadeAssociadaId: empresa === null || empresa === void 0 ? void 0 : empresa.id, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "email", label: "E-mail", control: control, required: true, disabled: disabledContato }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MaskedTextFieldControl, { name: "telefone", label: "Telefone", control: control, mask: PHONE_MASK, required: true, disabled: disabledContato }) })] }) }), _jsx(WizardButtons, { nextClick: handleSubmit(onSubmit), prevClick: handleClickBack, isSubmitting: isSubmitting })] }));
};
